import './TitreSousLaLoupe.css';

/**
 * Le titre d'une bulle de la Carte ou de la Hiérarchie, sous les touches de la carte (chantier
 * modes-de-la-carte, modification 02) : avec une info (« D », « C », « T »), l'info se pose à la
 * place du titre, et le titre reste dessous, invisible, pour garder la taille de la bulle : sa
 * place ne bouge pas, l'info trop longue se coupe. Sans info, le titre seul, comme toujours.
 */
export function TitreSousLaLoupe({ classe, titre, info }: { classe: string; titre: string; info: string | null }) {
  if (info === null) return <span className={classe}>{titre}</span>;
  return (
    <span className={`${classe} titre-sous-la-loupe`}>
      <span className="titre-sous-la-loupe-garde" aria-hidden="true">
        {titre}
      </span>
      <span className="titre-sous-la-loupe-info">{info}</span>
    </span>
  );
}
